<script>
  import Text from '@components/general/text.svelte'
  import { cn } from '@lib/utils'

  let { label, children, class: className } = $props()
</script>

<fieldset class={cn("border border-gray-200 rounded-lg p-5", className)}>
  {#if label}
    <Text variant="section_title" text={label} class="mb-4" />
  {/if}
  {@render children?.()}
</fieldset>
